// extracted by mini-css-extract-plugin
export var arrowPink = "WhyAttend-module--arrowPink--8d1b5";
export var description = "WhyAttend-module--description--2cdd0";
export var heading = "WhyAttend-module--heading--a1170";
export var insights = "WhyAttend-module--insights--ab2e2";
export var insightsCard = "WhyAttend-module--insightsCard--ae021";
export var number = "WhyAttend-module--number--36c3d";
export var numbers = "WhyAttend-module--numbers--726c2";
export var paragraph = "WhyAttend-module--paragraph--4388d";
export var saveSeatLink = "WhyAttend-module--saveSeatLink--6385b";
export var whyAttend = "WhyAttend-module--whyAttend--1952c";
export var wordsContent = "WhyAttend-module--wordsContent--ec15c";